export default __webpack_public_path__ + "static/media/profit.4f7bd177.svg";